const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 >
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<div class="column px-0 {~ColumnWidth:Record~}">
				<input
					type="hidden"
					tabindex="-1"
					{~D:Record.Macro.InputFullProperties~}
					{~D:Record.Macro.InputChangeHandler~}
					value=""
				 />
				<!-- <span>{~D:Record.Name~}:</span> -->
				<div {~D:Record.Macro.ControlAttr~} class="tabs is-centered is-boxed mb-0 mt-2">
					<ul id="TAB-SELECT-FOR-{~D:Record.Macro.RawHTMLID~}" role="tablist"></ul>
				</div>
				<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
			</div>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<li role="presentation" id="TAB-{~D:Context[1].TabGroupHash~}-{~D:Record.Macro.RawHTMLID~}"
				onclick="{~P~}.providers['Pict-Input-TabGroupSelector'].selectTabByViewHash('{~D:Context[0].Hash~}','{~D:Record.Hash~}', '{~D:Context[1].TabGroupHash~}');
					{~P~}.providers['Bulma-TableControls'].prepareAnyExtraTableControls();
					{~P~}.providers['Bulma-RecordSetControls'].prepareAnyExtraRecordSetControls();">
				<a role="tab" aria-selected="false" href="javascript:void(0);">
					<span class="icon mr-1">
						<i class="fa fa-fw fa-chevron-square-right"></i>
					</span>
					<span class="icon-text">{~D:Context[1].TabGroupName~}</span>
				</a>
			</li>`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<div class="notification p-5 has-text-centered">
				<span class="icon">
					<i class="fas fa-fw fa-exclamation-triangle"></i>
				</span>
				<span class="icon-text">Warning! No tabs to select from for {~D:Record.TabGroupSetRawHTMLID~}</span>
			</div>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector',
			DefaultInputExtensions: [ 'Pict-Input-TabGroupSelector' ],
			Template: /*HTML*/`
			<!-- InputType TabGroupSelector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<!-- the TabSelector Input provider deals with populating this from the manifest. -->
			<input
				class="pict-tab-group-print-host"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InputFullProperties~}
				{~D:Record.Macro.InputChangeHandler~}
				value=""
			 >
			<!-- NOTE: Intentionally empty in PRINT mode. The marker class lets the provider's CSS
			     collapse the host group, which would otherwise reserve an empty band in the PDF. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-TabElement',
			Template: /*HTML*/`
			<!-- Sections have "tab groups" which are defined by the hash of the Descriptor that hosts the current TabGroup value. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
		{
			HashPostfix: '-Template-Input-InputType-TabGroupSelector-EmptyGroupContent',
			Template: /*HTML*/`
			<!-- This is the template for if the tmpInput.PictForm.TabGroupSet array is empty. -->
			<!-- NOTE: Intentionally empty in PRINT mode. -->`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
